<template>
  <div class="min-h-screen flex flex-col">
    <nav class="bg-white shadow-lg">
      <div class="container mx-auto px-4">
        <div class="flex justify-between items-center h-16">
          <router-link to="/" class="text-2xl font-bold text-primary-800">
            ReacTCR
          </router-link>
          <div class="flex space-x-4">
            <router-link
              v-for="item in navItems"
              :key="item.path"
              :to="item.path"
              class="text-gray-700 hover:text-primary-800 px-3 py-2 rounded-md text-sm font-medium transition-colors"
              :class="{ 'text-primary-800 border-b-2 border-primary-800': $route.path === item.path }"
            >
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </div>
    </nav>

    <main class="flex-grow">
      <router-view></router-view>
    </main>

    <Footer />
  </div>
</template>

<script setup lang="ts">
import Footer from '@/components/layout/Footer.vue'

const navItems = [
  { name: 'Home', path: '/' },
  { name: 'Search', path: '/search' },
  { name: 'Browse', path: '/browse' },
  // { name: 'Download', path: '/download' },
  { name: 'Help', path: '/help' }
]
</script>

<style>
/* Global styles */
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;700&display=swap');

:root {
  --primary-color: #2D78AD;
  --primary-hover: #1B5A8F;
  --secondary-color: #4A5568;
  --accent-color: #F6AD55;
  --background-color: #F7FAFC;
  --text-color: #2D3748;
  --border-color: #E2E8F0;
}

body {
  font-family: 'Noto Sans SC', sans-serif;
  color: var(--text-color);
  background-color: var(--background-color);
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Transition animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Card shadow effect */
.card-shadow {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s ease;
}

.card-shadow:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

/* Button styles */
.btn {
  @apply px-4 py-2 rounded-lg font-medium transition-all duration-200;
}

.btn-primary {
  @apply bg-asblue text-white hover:bg-blue-600;
}

.btn-secondary {
  @apply bg-gray-200 text-gray-700 hover:bg-gray-300;
}

/* Input styles */
.input {
  @apply w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-asblue focus:border-transparent transition-all duration-200;
}

/* Link styles */
.link {
  @apply text-asblue hover:text-blue-600 transition-colors duration-200;
}

/* Heading styles */
h1 {
  @apply text-3xl font-bold text-gray-900 mb-6;
}

h2 {
  @apply text-2xl font-semibold text-gray-800 mb-4;
}

h3 {
  @apply text-xl font-medium text-gray-700 mb-3;
}

/* Paragraph styles */
p {
  @apply text-gray-600 leading-relaxed;
}
</style> 